<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p style="text-indent: 00em;">SJ Aspen is an Australian who loves to travel and see new places while meeting interesting people.</p><br/>
<p style="text-indent: 00em;">Previously, he had a career in government both in Australia and the Middle East. As a mature university student, he completed a bachelor of arts, a master’s in business administration and a master’s in information systems.</p><br/>
<p style="text-indent: 00em;">Today, SJ Aspen writes for the joy of presenting others with interesting and sometimes thought-provoking material. He likes to weave memories from his travels and life experiences into his storylines, often including a strong dose of reality that is balanced by a dash of humour.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?9abb6460